@if (uiState === 'showConsent') {
  <div class="page-container">
    <app-theme-toggle class="auth-theme-toggle" />
    <div class="center-column">
      <div class="content-container">
        <div class="logo-wrapper">Sign In with box.moe</div>
        <div>Hello {{consentRequest.subject}}</div>
        <header>{{consentRequest.client?.client_name || consentRequest.client?.client_id}} wants to access your box.moe account</header>
        <form novalidate class="ui form" [formGroup]="consentForm">
          @if (consentRequest.requested_scope) {
            <div class="scope-list">
              <div>{{consentRequest.client?.client_name || consentRequest.client?.client_id}} will have access to:</div>
              <ul>
                @for (scope of consentRequest.requested_scope; track scope) {
                  <li>
                    {{scope}}
                  </li>
                }
              </ul>
            </div>
          }
          <p>
            Do you want to be asked next time when this application wants to access your data? The application will
            not be able to ask for more permissions without your consent.
          </p>
          <ul>
            @if (consentRequest.client?.policy_uri) {
              <li><a [href]="consentRequest.client?.policy_uri">Policy</a></li>
            }
            @if (consentRequest.client?.tos_uri) {
              <li><a [href]="consentRequest.client?.tos_uri">Terms of Service</a></li>
            }
          </ul>
          <div class="field">
            <ui-toggle text="Remember My Choice" formControlName="remember"></ui-toggle>
          </div>
          <div>
            <button class="ui primary button" (click)="accept()">Accept</button>
            <button class="ui primary button" (click)="reject()">Reject</button>
          </div>
        </form>
      </div>
    </div>
  </div>
}
@if (uiState === 'error') {
  <div class="page-container">
    <app-theme-toggle class="auth-theme-toggle" />
    <div class="center-column">
      <div class="content-container">
        <p>{{uiError}}</p>
      </div>
    </div>
  </div>
}
